<div class="tw-flex tw-flex-col tw-gap-8">
  <div class="tw-flex tw-flex-col tw-w-full tw-gap-6">
    <app-input
      class="tw-w-full"
      [label]="inputOptions.label"
      [placeholder]="inputOptions.placeholder"
      [isRequired]="inputOptions.isRequired"
      (outputValue)="onInstitutionName($event)"
    ></app-input>
    <app-countries
      (selectedCountry)="setCountry($event)"
      [preSelected]="selectedCountry"
      [detachPanel]="true"
    ></app-countries>
  </div>

  <!-- Action Buttons -->
  <div class="tw-flex tw-gap-4 tw-w-full sm:tw-flex-col">
    <!-- Cancel Button -->
    <button type="button" (click)="cancel()" class="tw-flex tw-items-center tw-justify-center">
      <span
        class="tw-font-medium tw-text-[20px] tw-tracking-[0.005em] tw-leading-[135%] tw-text-dt-text-headings"
        >{{ "cancel" | i18n }}</span
      >
    </button>

    <!-- Save and Continue Button -->
    <button
      type="button"
      (click)="saveAndContinue()"
      class="tw-flex tw-w-full tw-items-center tw-justify-center tw-py-4 tw-px-6 tw-rounded-[50px] tw-bg-dt-surface-on-action tw-shadow-button-shadow"
    >
      <span
        class="tw-font-medium tw-text-[20px] sm:tw-text-[16px] tw-tracking-[0.005em] sm:tw-tracking-normal tw-leading-[135%] tw-text-dt-slate-0 tw-whitespace-nowrap"
        >{{ "saveAndContinue" | i18n }}</span
      >
    </button>
  </div>
</div>
